import styled, {css} from 'styled-components'

export const StyledWrapper = styled.div(
    ({theme: {palette}}) => css`
        background-color: ${palette.neutral.white};
        border-radius: 8px 8px 0 0;
        border: 1px solid ${palette.neutral[200]};
        border-bottom: none;
    `
)
